import type { EventName } from "@lit/react";
import { CheckboxGroup as CheckboxGroupElement, type CheckboxGroupEventMap as _CheckboxGroupEventMap, } from "@vaadin/checkbox-group/vaadin-checkbox-group.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { CheckboxGroupElement, };
export type CheckboxGroupEventMap = Readonly<{
    onInvalidChanged: EventName<_CheckboxGroupEventMap["invalid-changed"]>;
    onValidated: EventName<_CheckboxGroupEventMap["validated"]>;
    onValueChanged: EventName<_CheckboxGroupEventMap["value-changed"]>;
}>;
const events = { onInvalidChanged: "invalid-changed", onValidated: "validated", onValueChanged: "value-changed" } as CheckboxGroupEventMap;
export type CheckboxGroupProps = WebComponentProps<CheckboxGroupElement, CheckboxGroupEventMap>;
export const CheckboxGroup = createComponent({
    elementClass: CheckboxGroupElement, events, react: React, tagName: "vaadin-checkbox-group"
});
